export default "__VITE_ASSET__CPDLvyfH__"